<template>

  <div
    :class="sidebarClasses"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div
      id="style-3"
      class="sidebar-wrapper"
    >
      <div class="logo">
        <div class="simple-text">
          <div class="logo-img">
            <img src="/web/img/logo.png" alt="Logo" >
          </div>
          {{$root.attribute.name_company}} Monitoring
        </div>
      </div>
      <!-- user profile -->
      <user-profile-sidebar />
      <!-- end user profile -->

      <!-- dashboard -->
<!--      <div class="dashboard">-->
<!--        <router-link :to="{path: 'dashboard'}" class="simple-text">-->
<!--          <i class="mdi mdi-map" />-->
<!--          <p class="" :title="translate('dashboard.main')">-->
<!--            {{ translate('dashboard.main') }}-->
<!--          </p>-->
<!--        </router-link>-->
<!--      </div>-->

      <ul :class="navClasses">
        <li v-for="(link) in dashboard_link" :key="link.path" :style="link.style">
          <router-link :to="link.path" >
            <i class="mdi" :class="link.icon" />
            <p :class="[link.sub ? 'sub' + link.sub : '', link.class]" :title="link.title">
              <span v-if="link.sub !== undefined && link.sub > 0" class="horizon"></span>
              <span v-if="link.showvert"><span v-for="n in link.sub"  :key="n" :class="'subvert'+n"></span></span>
              {{ link.name }}
            </p>
          </router-link>
        </li>
      </ul>

      <!-- end dashboard -->

      <!-- device section -->
      <v-tree class="menu_list_device" v-if="modules.devices" :data="device_list" :tpl='tpl' />
      <v-tree class="menu_list_device" v-if="modules.devices" :data="simcard_devices" :tpl='tpl' />
      <v-tree class="menu_list_settings" v-if="modules.devices" :data="managementGroups" :tpl='settingsTpl' :selectAlone='true' />
      <!-- end device section -->

      <v-tree class="menu_list_settings bottom_gray" v-if="modules.settings" :data="serversList" :tpl='settingsTpl' />

      <!-- simcard section -->
      <v-tree class="menu_list_device" v-if="modules.simcard_profiles" :data="simcard_profile" :tpl='tpl' />

      <ul :class="navClasses">
        <li v-for="(link) in sidebar_simcard_links" :key="link.path" :style="link.style">
          <router-link :to="link.path" >
            <i class="mdi" :class="link.icon" />
            <p :class="[link.sub ? 'sub' + link.sub : '', link.class]" :title="link.title">
              <span v-if="link.sub > 0" class="horizon"></span>
              <span v-if="link.showvert"><span v-for="n in link.sub"  :key="n" :class="'subvert'+n"></span></span>
              {{ link.name }}
            </p>
          </router-link>
        </li>
      </ul>
      <!-- end simcard section -->

      <!-- common section -->
      <ul :class="navClasses">
        <li v-for="(link) in sidebar_common_links" :key="link.path" :style="link.style">
          <router-link :to="link.path" >
            <i class="mdi" :class="link.icon" />
            <p :class="[link.sub ? 'sub' + link.sub : '', link.class]" :title="link.title">
              <span v-if="link.sub > 0" class="horizon"></span>
              <span v-if="link.showvert"><span v-for="n in link.sub"  :key="n" :class="'subvert'+n"></span></span>
              {{ link.name }}
            </p>
          </router-link>
        </li>
      </ul>
      <!-- end common section -->
      <v-tree class="menu_list_settings" v-if="modules.settings" :data="settingsList"  :tpl='settingsTpl' />

    </div>
  </div>
</template>
<script>
import UserProfileSidebar from './UserProfileSidebar.vue'
import VTree from "vue-tree-halower";

export default {
  components: {
    VTree,
    UserProfileSidebar
  },
  props: {
    type: {
      type: String,
      default: 'sidebar',
      validator: (value) => {
        let acceptedValues = ['sidebar', 'navbar']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: (value) => {
        let acceptedValues = ['white', 'black', 'darkblue']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      parents: {},
      device_nodes: {},
      simcard_devices_nodes: {},
      simcard_profile_nodes: {},
      device_links: [],
      simcard_devices_links: [],
      simcard_profile_links: [],
      device_list: [],
      simcard_devices: [],
      simcard_profile: [],
      settingsList: [],
      serversList: [],
      managementGroups: [],
      linkHeight: 60,
      activeLinkIndex: 0,
      sidebar_simcard_links: [],
      sidebar_common_links: [],
      dashboard_link: [],
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      child_links: {}
    }
  },
  computed: {
    modules(){
      return this.$store.getters.getModules
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
    tickets_count(){
      return this.$store.getters.getTicketCount
    },
    sidebarClasses () {
      if (this.type === 'sidebar') {
        return 'sidebar'
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar'
      }
    },
    lang () { return this.language },
    navClasses () {
      if (this.type === 'sidebar') {
        return 'nav'
      } else {
        return 'nav navbar-nav'
      }
    },
  },
  watch: {
    tickets_count(){
      this.setLinks()
    },
    lang () {
      this.setLinks()
    },
    link_group () {
      this.setLinks()
    },
  },
  mounted () {
    this.setLinks()
  },

  methods: {
    scroll_bottom(){
      //При открытии настроек, сидебар всегда скролился вниз
      this.$nextTick(() => {
        let sidebar = this.$el.querySelector("#style-3")
        sidebar.scrollTop = sidebar.scrollHeight;
      })
    },


    tpl(...args) {
      let {0: node} = args
      let cross = ''
      if (node.close !== false) {
        cross = <span onClick={($event) => node.click(node, $event)} class="mdi mdi-close-box darksalmon" />
      }else if (node.name === "List device" && node.children.length > 0) {
        cross = <span onClick={($event) => this.clearHistoryDevice(node, $event)} class="mdi mdi-close-circle darksalmon" />
      }
      node.icon  = node.class !== 'icon_list_device' && node.children?.length === 0 ? 'mdi-playlist-plus' : ''
      return <router-link custom key={node.path} to={node.path} class={node.class ? node.class : ''}>
          <i
              class={'mdi ' + node.icon}
              style="font-size: 24px;"
          />
          {node.name}
          {cross}
      </router-link>
    },

    settingsTpl(...args) {
      let {0: node} = args
      if (node.path === '') {
        return <span
          class={node.class ? node.class : ''}
          onClick={() => {
            setTimeout(this.scroll_bottom, 400)
            node.expanded = !node.expanded
          }}>
          <i
              class={'mdi ' + node.icon}
              style="font-size: 24px;"
          />
          {node.name}
        </span>
      }else{
        return <router-link custom key={node.path} to={node.path} class={node.class ? node.class : ''}>
            <i
                class={'mdi ' + node.icon}
                style="font-size: 24px;"
            />
            {node.name}
        </router-link>
      }
    },

    deleteLink(link, event) {
      event.preventDefault()
      this.$store.dispatch('delete_link_device', {group: link.group, id: link.id})
      if (this.$route.name === 'device_section' && this.$route.params.device_id === link.id) {
          this.$router.push('/device_group/' + link.group)
      }
    },

    deleteLinkSimcardDevices(link, event) {
      event.preventDefault()
      this.$store.dispatch('deleteLinkSimcardDevices', {group: link.group, id: link.id})
      if (this.$route.name === 'simcard_devices_section' && this.$route.params.simcard_device_id === link.id) {
          this.$router.push('/simcard_devices_group/' + link.group)
      }
    },

    deleteLinkSimcardProfile(link, event) {
      event.preventDefault()
      this.$store.dispatch('deleteLinkSimcardProfile', {group: link.group, id: link.id})
      if (this.$route.name === 'simcard_profile_section' && this.$route.params.simcard_profile_id === link.id) {
          this.$router.push('/simcard_profile_list/')
      }
    },

    getChildGroup(link, ids) {
      if(link.children) {
        for (let i in link.children) {
          ids.push(+i)
          if(link.children[i].children) {
            ids = [...new Set ([...ids, ...this.getChildGroup(link.children[i], ids)])]
          }
        }
      }
      return ids
    },

    deleteLinkDevicesGroup(link, event) {
      event.preventDefault()
      let ids = [];
      ids =  this.getChildGroup(this.device_nodes[link.id], ids)
      ids.push(+link.id)

      this.$store.dispatch('delete_link_group_device', {ids: ids, parent: link.parent})

      let redirect = false

      if (this.$route.name === 'device_list_group' && ids.includes(+this.$route.params.device_group_id) ||
          this.$route.name === 'device_section' && ids.includes(this.$store.getters.getDeviceById(this.$route.params.device_id).profile.group_id)
      ) {
        redirect = true
      }

      if(redirect) {
        if (link.parent === undefined || +link.parent === -1) {
          this.$router.push('/')
        } else {
          this.$router.push('/device_group/' + link.parent)
        }
      }
      return true
    },

    deleteLinkGroupSimcardDevices(link, event) {
      event.preventDefault()
      let ids = [];
      ids =  this.getChildGroup(this.simcard_devices_nodes[link.id], ids)
      ids.push(+link.id)

      this.$store.dispatch('deleteLinkGroupSimcardDevices', {ids: ids, parent: link.parent})

      let redirect = false

      if (this.$route.name === 'simcard_list_group' && ids.includes(+this.$route.params.simcard_devices_group_id) ||
          this.$route.name === 'simcard_devices_section' && ids.includes(this.$store.getters.getSimcardDevicesById(this.$route.params.simcard_devices_id).profile.group_id)
      ) {
        redirect = true
      }

      if(redirect) {
        this.$router.push('/simcard_devices_list')
      }
      return true
    },

    addLinkDevices(children) {
      let group = this.$store.getters.getDeviceGroupById((children.group) ? children.group : children.parent)

      if(group.status === 'unknw') {
        return false
      }

      if (!this.device_nodes[group.id] ) {
        if (group.name.length > 20) {  //TODO: добавить завсимость от вложенности
          group.name_shrt = group.name.substr(0, 18) + '...'
        } else {
          group.name_shrt = group.name
        }
        this.device_nodes[group.id] = {
          id: group.id,
          parent: (group.parent === undefined) ? 0 : group.parent,
          expanded: true,
          click: this.deleteLinkDevicesGroup,
          name: group.name_shrt,
          title: group.name,
          path: '/device_group/' + group.id,
          icon: '',
          value: {},
          children: {}
        }
        if (children.group) {
          this.device_nodes[group.id].value[children.id] = children
        } else {
          this.device_nodes[group.id].children[children.id] = children
        }
      } else {
        if (children.group !== undefined) {
          this.device_nodes[group.id].value = {...this.device_nodes[group.id].value, ...{[children.id]: children}}
        } else {
          if (this.device_nodes[group.id].children[children.id] === undefined) {
            this.device_nodes[group.id].children[children.id] = children
          }
        }
      }

      if (+group.parent > -1) {
        let gr = this.$store.getters.getDeviceGroupById(group.parent, true)
        if (gr.status === 'unknw') {
          this.device_nodes[group.id].parent = -1
        } else {
          this.addLinkDevices(this.device_nodes[group.id])
        }
      }
    },

    addLinkSimcardDevices(children) {
      let group = this.$store.getters.getSimcardDevicesGroupById((children.group) ? children.group : children.parent)

      if(group.status === 'unknw') {
        return false
      }

      if (!this.simcard_devices_nodes[group.id] ) {
        if (group.name.length > 20) {  //TODO: добавить завсимость от вложенности
          group.name_shrt = group.name.substr(0, 18) + '...'
        } else {
          group.name_shrt = group.name
        }
        this.simcard_devices_nodes[group.id] = {
          id: group.id,
          parent: (group.parent === undefined) ? 0 : group.parent,
          expanded: true,
          click: this.deleteLinkGroupSimcardDevices,
          name: group.name_shrt,
          title: group.name,
          path: '/simcard_devices_group/' + group.id,
          icon: '',
          value: {},
          children: {}
        }
        if (children.group) {
          this.simcard_devices_nodes[group.id].value[children.id] = children
        } else {
          this.simcard_devices_nodes[group.id].children[children.id] = children
        }
      } else {
        if (children.group !== undefined) {
          this.simcard_devices_nodes[group.id].value = {...this.simcard_devices_nodes[group.id].value, ...{[children.id]: children}}
        } else {
          if (this.simcard_devices_nodes[group.id].children[children.id] === undefined) {
            this.simcard_devices_nodes[group.id].children[children.id] = children
          }
        }
      }

      if (+group.parent > -1) {
        let gr = this.$store.getters.getSimcardDevicesGroupById(group.parent, true)
        if (gr.status === 'unknw') {
          this.simcard_devices_nodes[group.id].parent = -1
        } else {
          this.addLinkSimcardDevices(this.simcard_devices_nodes[group.id])
        }
      }
    },

    addLinkSimcardProfile(children) {
      if (!this.simcard_profile_nodes[children.id] ) {
        this.simcard_profile_nodes[children.id] = children
      }
    },

    getlinksarray(node) {
      let link = {...node};
      link.children = []
      delete link.value

      for (let i in node.value) {
        link.children.push(node.value[i])
      }
      if (Object.keys(node.children) !== 0) {
        for (let i in node.children) {
          link.children.push(this.getlinksarray(node.children[i]))
        }
      }
      return link
    },

    getDeviceslinks() {
      this.device_nodes = {}
      let list = this.$store.getters.getDeviceLinks

      for (let i in list) {
        for (let j in list[i]) {
          let short_name = ''
          if (list[i][j].name.length > 18) {
            short_name = list[i][j].name.substr(0, 16) + '...'
          } else {
            short_name = list[i][j].name
          }
          this.addLinkDevices({
            id: j,
            click: this.deleteLink,
            name: short_name,
            group: i,
            path: list[i][j].path,
            icon: '',
            title: list[i][j].name
          })
        }

        if (list[i] !== undefined && Object.keys(list[i]).length === 0) {
          let group = this.$store.getters.getDeviceGroupById(i)
          if (group.name.length > 20) {  //TODO: добавить завсимость от вложенности
            group.name_shrt = group.name.substr(0, 18) + '...'
          } else {
            group.name_shrt = group.name
          }
          this.device_nodes[i] = {
            id: group.id,
            parent: (group.parent === undefined) ? 0 : group.parent,
            expanded: true,
            click: this.deleteLinkDevicesGroup,
            name: group.name_shrt,
            title: group.name,
            path: '/device_group/' + group.id,
            icon: '',
            value: {},
            children: {}
          }
          this.addLinkDevices(this.device_nodes[i])
        }
      }
      let links = []
      for (let i in this.device_nodes) {
        if (this.device_nodes[i].parent === -1) {
          links.push(this.getlinksarray(this.device_nodes[i]))
        }
      }
      this.device_links = links
      return this.device_links
    },

    getSimcardDevicesLinks() {
      this.simcard_devices_nodes = {}
      let list = this.$store.getters.getSimcardDevicesLinks
      for (let i in list) {
        for (let j in list[i]) {
          let short_name = ''
          if (list[i][j].name.length > 18) {
            short_name = list[i][j].name.substr(0, 16) + '...'
          } else {
            short_name = list[i][j].name
          }
          this.addLinkSimcardDevices({
            id: j,
            click: this.deleteLinkSimcardDevices,
            name: short_name,
            group: i,
            path: list[i][j].path,
            icon: '',
            title: list[i][j].name
          })
        }

        if (list[i] !== undefined && Object.keys(list[i]).length === 0) {
          let group = this.$store.getters.getSimcardDevicesGroupById(i)
          if (group.name.length > 20) {  //TODO: добавить завсимость от вложенности
            group.name_shrt = group.name.substr(0, 18) + '...'
          } else {
            group.name_shrt = group.name
          }
          this.simcard_devices_nodes[i] = {
            id: group.id,
            parent: (group.parent === undefined) ? 0 : group.parent,
            expanded: true,
            click: this.deleteLinkGroupSimcardDevices,
            name: group.name_shrt,
            title: group.name,
            path: '/simcard_devices_group/' + group.id,
            icon: '',
            value: {},
            children: {}
          }
          this.addLinkSimcardDevices(this.simcard_devices_nodes[i])
        }
      }
      let links = []
      for (let i in this.simcard_devices_nodes) {
        if (this.simcard_devices_nodes[i].parent === -1) {
          links.push(this.getlinksarray(this.simcard_devices_nodes[i]))
        }
      }
      this.simcard_devices_links = links
      return this.simcard_devices_links
    },

    getSimcardProfileLinks() {
      this.simcard_profile_nodes = {}
      let list = this.$store.getters.getSimcardProfileLinks
      for (let i in list) {
        let short_name = ''
        if (list[i].name.length > 18) {
          short_name = list[i].name.substr(0, 16) + '...'
        } else {
          short_name = list[i].name
        }
        this.addLinkSimcardProfile({
          id: i,
          click: this.deleteLinkSimcardProfile,
          name: short_name,
          path: list[i].path,
          icon: '',
          title: list[i].name,
          parent: -1
        })
      }

      let links = []
      for (let i in this.simcard_profile_nodes) {
        if (this.simcard_profile_nodes[i].parent === -1) {
          links.push(this.simcard_profile_nodes[i])
        }
      }
      this.simcard_profile_links = links
      return this.simcard_profile_links
    },

    clearHistoryDevice(link, event) {
      event.preventDefault()
      this.$store.dispatch('clear_history_device', {link: link})
      this.$router.push(link.path)
    },

    createLinks() {
      this.device_links = {}
      this.simcard_devices_links = {}
      this.getDeviceslinks()
      this.getSimcardDevicesLinks()
      this.getSimcardProfileLinks()

      let device_list = [
        {
          name: this.translate('device.many'),
          icon: '',
          class: 'icon_list_device',
          path: '/device_list',
          expanded: true,
          close: false,
          children: [...this.device_links]
        }
      ]

      let simcard_devices = [
        {
          name: this.translate('simcard_devices.list'),
          icon: 'mdi-sim',
          path: '/simcard_devices_list',
          class: 'icon_list_device',
          expanded: true,
          close: false,
          children: [...this.simcard_devices_links]
        }
      ]

      let simcard_profile = [
        {
          name: this.translate('simcard_profile.many'),
          icon: 'mdi-sim',
          path: '/simcard_profile_list',
          class: 'icon_list_device',
          expanded: true,
          close: false,
          children: [...this.simcard_profile_links]
        }
      ]

      let managementGroups = [
        {
          name: this.translate('management.groups/list'),
          class: '',
          expanded: false,
          hasExpanded: true,
          close: false,
          path: '',
          children: [
            {
              name: this.translate('custom.title'),
              class: 'sub-settings',
              icon: 'mdi-format-list-bulleted-square',
              path: '/custom_device_list',
              close: false,
            },
          ]
        }
      ]

      if (this.permissions.viewDeviceGroupList){
        managementGroups[0].children.push(
          {
            name: this.translate('device.group.many'),
            class: 'sub-settings',
            icon: 'mdi-group',
            path: '/device_groups',
            close: false,
          }
        )
      }

      if (this.permissions.viewDeviceSimcardGroups){
        managementGroups[0].children.push(
          {
            name: this.translate('simcard_devices_group_list.many'),
            class: 'sub-settings',
            icon: 'mdi-group',
            path: '/simcard_devices_group_list',
            close: false,
          }
        )
      }

      let serversList = [
        {
          name: this.translate('server.many'),
          class: '',
          expanded: false,
          hasExpanded: true,
          close: false,
          path: '',
          children: [
            {
              name: this.translate('server.many'),
              class: 'sub-settings',
              icon: 'mdi-server',
              path: '/servers/all',
              close: false,
            },
            {
              name: this.translate('ip_profile.address'),
              class: 'sub-settings',
              icon: 'mdi-lan',
              path: '/ips/list',
              close: false,
            },
            {
              name: this.translate('proxy_server.many'),
              class: 'sub-settings',
              icon: 'mdi-cogs',
              path: '/proxy_servers',
              close: false,
            },

          ]
        }
      ]

      let settingsList = [
        {
          name: this.translate('settings.many'),
          class: '',
          expanded: false,
          hasExpanded: true,
          close: false,
          path: '',
          children: [
            {
              name: this.translate('utilities.many'),
              class: 'sub-settings',
              icon: 'mdi-alpha-u-circle-outline',
              path: '/utilities',
              close: false,
            },
            {
              name: this.translate('task.many'),
              class: 'sub-settings',
              icon: 'mdi-playlist-check',
              path: '/tasks',
              close: false,
            },
            {
              name: this.translate('global_settings.many'),
              class: 'sub-settings',
              icon: 'mdi-cogs',
              path: '/global_settings',
              close: false,
            },
            {
              name: this.translate('device_models.many'),
              class: 'sub-settings',
              icon: 'mdi-router-wireless',
              path: '/models_list',
              close: false,
            },
            {
              name: this.translate('monitoring_status.name'),
              class: 'sub-settings',
              icon: 'mdi-cogs',
              path: '/monitoring_status',
              close: false,
            }
          ]
        }
      ]

      let links_simcard = {}

      if (this.modules.simcard_profiles) {
        if (this.permissions.viewSimcardProfile){
          links_simcard = Object.assign(links_simcard, {
            'esim_profile_list':{
              name: this.translate('esim_profile.many'),
              icon: 'mdi-card-bulleted',
              path: '/esim_profile_list',
              // style: "border-bottom: 1px solid gray;",
            }
          })
        }
        if (this.permissions.controlSimcardProfile){
          links_simcard = Object.assign(links_simcard, {
            'communication_management':{
              name: this.translate('communication_management.many'),
              icon: 'mdi-cogs',
              path: '/communication_management',
              style: "border-bottom: 1px solid gray; padding-bottom: 10px;",
            },
          })
        }
      }

      let links_common = {}

      if (this.modules.users) {
        links_common.usermanagment = {
          name: this.translate('user.many'),
          icon: 'mdi-account-multiple',
          path: '/usermanagment',
          separator: true,
        }
      }

      if (this.modules.clients) {
        links_common.clients = {
          name: this.translate('client.many'),
          icon: 'mdi-account-group',
          path: '/clients'
        }
      }
      if (this.$store.getters.getPermissions?.permissionGod === true) {
        links_common.company_services = {
          name: this.translate('company_services.many'),
          icon: 'mdi-account-cash',
          path: '/company_services/tariffs',
          style: "padding-bottom: 10px;",
        }
      }


      if (this.modules.notifications) {
        links_common.notification = {
          name: this.translate('notification.many'),
          icon: 'mdi-bell',
          path: '/notification/profiles',
          style: "border-top: 1px solid gray;",
        }
      }

      //Проверка на permissions пользователя
      if (this.$store.getters.getPermissions?.permissionSupport === true && this.modules.supports) {
        links_common.supports = {
          name: this.translate('support.main'),
          icon: 'mdi-face-agent',
          path: '/supports'
        }
        if (this.tickets_count > 0){
          links_common.supports.name += ' (' + this.tickets_count + ')'
        }
      }

      let link_dashboard = {}
      if (this.permissions.viewDashboard){
        link_dashboard = Object.assign(link_dashboard, {
          'dashboard':{
            name: this.translate('dashboard.main'),
            icon: 'mdi-map',
            path: '/dashboard',
          },
        })
      }

      let dashboard_link = []
      if (this.$store.getters.getPermissions.viewDashboard === true){
        for (let i in link_dashboard) {
          dashboard_link.push(link_dashboard[i])
        }
      }

      this.dashboard_link = [...dashboard_link]


      let sidebar_simcard = []
      if (this.$store.getters.getPermissions?.permissionGod === true){
        for (let i in links_simcard) {
          sidebar_simcard.push(links_simcard[i])
        }
      }
      this.sidebar_simcard_links = [...sidebar_simcard]

      let sidebar_common = []
      for (let i in links_common) {
          sidebar_common.push(links_common[i])
      }
      this.sidebar_common_links = [...sidebar_common]

      this.device_list = [...device_list]
      this.managementGroups = [...managementGroups]

      if (this.$store.getters.getPermissions?.permissionGod === true) { //Добавляем секции если пользователь god
        this.simcard_devices = [...simcard_devices]
        this.simcard_profile = [...simcard_profile]
        this.settingsList = [...settingsList]
        this.serversList = [...serversList]
      }

    },

    setLinks() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.createLinks, 500)
    }
  }
}

</script>
<style lang="scss" scoped>
  .darksalmon {
    color: darksalmon;
  }
  .nav > li > a{
    padding: 10px 15px 0;
  }

  @media (max-width: 991px){
    .off-canvas-sidebar{
      .nav{
        &>li{
          &>a{
            .mdi{
              margin-right: 3px;
            }
            p{
              display: inherit !important;
            }
          }
        }
      }
    }
  }

</style>
